<template>
  <section class="schedule">
    <schedule-list2
      v-if="is1yuan"
      page="schedule"
      :dataSource="dataSource"
      @fold="handleFoldSection"
    />

    <schedule-list
      v-else
      page="schedule"
      :dataSource="dataSource"
      :has-buy="true"
      @fold="handleFoldSection"
    />
  </section>
</template>

<script>
import os from '@edu-fe/os'
import { mapState, mapActions, mapMutations } from 'vuex'

import ScheduleList from '../components/ScheduleList.vue'
import ScheduleList2 from '../components/ScheduleList2.vue'
import module from '../modules/schedule'
import ShareMaker from '../lib/shareMaker'

export default {
  name: 'Schedule',
  data () {
    return {
      routeFrom: ''
    }
  },
  computed: {
    ...mapState(module.name, {
      dataSource: state => state.data
    }),

    // 是否是1元课
    is1yuan () {
      // return true // 测试
      return os.type === 'weixin' && this.dataSource.isPromote === 1
    }
  },
  components: {
    ScheduleList,
    ScheduleList2
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    const { courseId } = this.$route.query

    this['schedule/getData']({
      courseId
    }).then(data => {
      const href = `${location.protocol}//${location.host}${this.$route.fullPath}`
      // const link = `https://course-m.auoktalk.com/sign-up?courseId=${courseId}`
      const link = window.location.href
      const title = data.shareContent || data.courseName

      if (this.routeFrom === 'mine') {
        // 从 "我的课程" 过来
        return new ShareMaker({
          title,
          introduction: title,
          imgUrl: data.image,
          link
        }, href, true)
      } else {
        return new ShareMaker({
          title: '微课',
          introduction: data.courseName,
          imgUrl: 'https://staticedu.wps.cn/static_file/pictures/watermark/logo.jpg',
          link
        }, href, true)
      }
    })
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.routeFrom = from.name || ''
    })
  },

  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },

  methods: {
    ...mapActions([
      'schedule/getData'
    ]),
    ...mapMutations([
      'schedule/setFoldSection'
    ]),
    handleFoldSection (section) {
      this['schedule/setFoldSection'](section)
    }
  }
}
</script>

<style lang="scss">
@charset 'utf-8';
@import '../style/main';

$global-width: 750;

.schedule {
  background-color: #efefef;
  font-family: PingFangSC-Regular;
  color: #333;
}

$global-width: 720;
</style>
